import * as React from "react";

import movBackground from "../../movies/movie-background.mp4"

import * as S from './styles';

export default function Banner({setModal}) {
  const [user, setUser] = React.useState('');
  const [alert, setAlert] = React.useState(false);

  function handleSubmitClaim(){
    if (user.length !== 0) {
      // window.location = `#`;
      setModal(true);
    } else {
      setAlert(true);
      setTimeout(() => {
        setAlert(false);
      }, 4000);
    }
  }

  return (
    <S.Container>
      <S.Content>
        <h1>Helping Influencers</h1>
        <S.Text>Helping Influencers</S.Text>
        <S.Text>Connect to Brands</S.Text>
        <S.Input>
          <span>talentjuice.co.uk/</span>
          <input
            type="text"
            placeholder="name"
            onChange={ event => setUser(event.target.value) }
            value={user}
          />
          <S.Button onClick={handleSubmitClaim}>Claim</S.Button>
        </S.Input>
        <S.Alert isVisible={alert}>Enter a name to proceed</S.Alert>
        <S.Info>
          <S.Text className="recursive">Type your name above to get started !</S.Text>
        </S.Info>
        <S.Movie>
          <video autoPlay muted loop playsInline>
            <source src={movBackground} type="video/mp4" />
          </video>
        </S.Movie>
      </S.Content>
    </S.Container>
  )
}